import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Determine the base URL based on the environment
const baseURL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_PROD_BASE_URL
  : process.env.REACT_APP_DEV_BASE_URL;

const Typewriter = ({ content, speed = 50, onComplete }) => {
  const [displayedContent, setDisplayedContent] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [typingText, setTypingText] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < content.length) {
      const currentItem = content[currentIndex];

      if (currentItem.type === "text") {
        if (charIndex < currentItem.value.length) {
          const timer = setTimeout(() => {
            setTypingText((prev) => prev + currentItem.value[charIndex]);
            setCharIndex((prev) => prev + 1);
          }, speed);
          return () => clearTimeout(timer);
        } else {
          // Finish typing text
          setDisplayedContent((prev) => [
            ...prev,
            { type: "text", value: typingText },
          ]);
          setTypingText("");
          setCharIndex(0);
          setCurrentIndex((prev) => prev + 1);
        }
      } else if (currentItem.type === "image") {
        // Immediately display images
        const imageUrl = currentItem.src.startsWith('http')
          ? currentItem.src
          : `${currentItem.src}`;
        setDisplayedContent((prev) => [
          ...prev,
          { ...currentItem, src: imageUrl },
        ]);
        setCurrentIndex((prev) => prev + 1);
      }
    } else if (onComplete) {
      onComplete(); // Notify when all content is displayed
    }
  }, [content, currentIndex, charIndex, speed, typingText, onComplete]);

  return (
    <div
      style={{
        whiteSpace: "pre-wrap",
        fontFamily: "monospace",
        fontSize: "1.2rem",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {displayedContent.map((item, index) =>
        item.type === "text" ? (
          <div key={index}>{item.value}</div>
        ) : (
          <img
            key={index}
            src={item.src}
            alt={item.alt || "Embedded Content"}
            className={item.className} // Apply className to the image
            style={{ maxWidth: "100%"}}
          />
        )
      )}
      {typingText && <div>{typingText}</div>}
    </div>
  );
};

Typewriter.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["text", "image"]).isRequired,
      value: PropTypes.string, // Required for text
      src: PropTypes.string, // Required for image
      alt: PropTypes.string, // Optional for image
      className: PropTypes.string, // Optional for image
    })
  ).isRequired,
  speed: PropTypes.number, // Typing speed in ms
  onComplete: PropTypes.func, // Callback when all content is displayed
};

export default Typewriter;
